import { environmentHttpClient } from "client/Api/httpClient";
export enum PopupItemKind {
	Announcement = 1,
	Event = 2
}

export type PopupItemModel = {
	id: number;
} & ({
	kind: PopupItemKind.Announcement;
	announcementId: number;
} | {
	kind: PopupItemKind.Event;
	eventId: number;
});

export type PopupPostponeModel = {
	ids: readonly number[];
	postponeUntil: Date;
};

export function getPopupQueue(signal?: AbortSignal): Promise<readonly PopupItemModel[]> {
	return environmentHttpClient.get<readonly PopupItemModel[]>(
		"/PopupQueue",
		undefined,
		{ signal }
	);
}

export function markAsRead(popupId: number, signal?: AbortSignal): Promise<void> {
	return environmentHttpClient.put<void>(
		`/PopupQueue/${popupId}/read`,
		undefined,
		{ signal }
	);
}

export function postpone(model: PopupPostponeModel, signal?: AbortSignal): Promise<void> {
	return environmentHttpClient.post<void>(
		`/PopupQueue/Postpone`,
		model,
		{ signal }
	);
}